import { useState } from "react";
import styled from "styled-components";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ColumnType } from "antd/es/table/interface";
import { useTranslation } from "react-i18next";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { Checkbox } from "@renderbus/ui";

export function ColumnCheckboxes({
  columns,
  value,
  defaultValue,
  onChange,
}: {
  columns: ColumnType<any>[];
  span?: number;
  value?: CheckboxValueType[];
  defaultValue?: CheckboxValueType[];
  onChange?: (v: CheckboxValueType[]) => void;
}) {
  const isDefaultCheckAll =
    value && defaultValue ? value.length === defaultValue.length : false;
  const { t } = useTranslation("center");
  const [checkAll, setCheckAll] = useState(isDefaultCheckAll);
  const [indeterminate, setIndeterminate] = useState(!isDefaultCheckAll);
  const [checkedList, setCheckedList] = useState<CheckboxValueType[]>(
    value || []
  );

  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    setCheckedList(e.target.checked ? defaultValue || value || [] : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    if (!onChange) return;
    onChange(e.target.checked ? defaultValue || value || [] : []);
  };

  const onCheckChange = (list: CheckboxValueType[]) => {
    if (!defaultValue) return;
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < defaultValue.length);
    setCheckAll(list.length === defaultValue.length);
    if (!onChange) return;
    onChange(list);
  };
  return (
    <ColumnCheckboxesContainer>
      <Checkbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        {t("common_check_all")}
      </Checkbox>
      <Checkbox.Group
        onChange={onCheckChange}
        value={checkAll ? checkedList : value}
      >
        <ColumnCheckboxesWrapper>
          {columns.map((item) => {
            const key = item.key
              ? item.key.toString()
              : item.dataIndex?.toString();
            return (
              <Checkbox value={key} key={key}>
                <span>{item.title?.toString()}</span>
              </Checkbox>
            );
          })}
        </ColumnCheckboxesWrapper>
      </Checkbox.Group>
    </ColumnCheckboxesContainer>
  );
}

const ColumnCheckboxesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: scroll;
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
  }
`;

const ColumnCheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
